import {PaymentOptionType as PaymentOptionTypeGQL} from '@wix/wixstores-graphql-schema-node';
import {PriceModel} from '../Price.model';

export class PaymentConfigModel {
  public savePaymentMethod: boolean;
  public depositAmount: PriceModel;
  public paymentOption: PaymentOptionType;

  constructor(params: PaymentConfigModel) {
    this.savePaymentMethod = params.savePaymentMethod;
    this.depositAmount = params.depositAmount;
    this.paymentOption = params.paymentOption;
  }

  public static fromCartV1({
    savePaymentMethod,
    depositAmount,
    paymentOption,
  }: {
    savePaymentMethod: boolean;
    depositAmount: PriceModel;
    paymentOption: PaymentOptionTypeGQL;
  }): PaymentConfigModel {
    return new PaymentConfigModel({savePaymentMethod, depositAmount, paymentOption: paymentOptionMap[paymentOption]});
  }
}

export enum PaymentOptionType {
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER',
}

const paymentOptionMap: Record<PaymentOptionTypeGQL, PaymentOptionType> = {
  [PaymentOptionTypeGQL.DEPOSIT_ONLINE]: PaymentOptionType.DEPOSIT_ONLINE,
  [PaymentOptionTypeGQL.MEMBERSHIP]: PaymentOptionType.MEMBERSHIP,
  [PaymentOptionTypeGQL.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER]:
    PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER,
  [PaymentOptionTypeGQL.MEMBERSHIP_OFFLINE]: PaymentOptionType.MEMBERSHIP_OFFLINE,
  [PaymentOptionTypeGQL.FULL_PAYMENT_OFFLINE]: PaymentOptionType.FULL_PAYMENT_OFFLINE,
  [PaymentOptionTypeGQL.FULL_PAYMENT_ONLINE]: PaymentOptionType.FULL_PAYMENT_ONLINE,
};
